import React, { Component } from "react";
import "../css/product.css";
import {Glyphicon, OverlayTrigger, Table, Form} from 'react-bootstrap';
import {tooltip, toInt, formatNumber, HtmlTooltip} from '../Utils';
import XLSX from 'xlsx';
import { ProductService } from "../Services/ProductService";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { ROLES } from "../Roles";
import { IconButton, Icon, Grid, Dialog, DialogContent, DialogTitle, DialogActions, ListItemText } from "@material-ui/core";
import CustomDialog from "../components/CustomDialog";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ImportService } from "../Services/ImportService";
import MyDialog from "../components/MyDialog";

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    margin: {
        margin: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    paper: {
        position: 'absolute',
        width: theme.spacing(50),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };
  
  const grid = 8;
  
  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
  
    // change background colour if dragging
    background: isDragging ? "#bdbdbd" : "#fafafa",
  
    // styles we need to apply on draggables
    ...draggableStyle
  });
  
  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "white",
    padding: grid,
    width: '100%'
  });

class Product extends Component {

    constructor(props) {
      super(props);

      this.state = {
        data: [],
        originalData: [],
        rows: [],
        show: false,
        new_product: { name: "", barcode: null, display_name: "", category: "1", hsncode: "", unit_size: "", unit_price: 0, sgst: 0, cgst: 0, igst: 0, bottled: "0", auto_schedule_enabled: "1", crate_size: 0, indent_inc_percentage: 0},
        sheet: "Products",
        filename: "HappyMilk - Product List",

        openSortDialog: false,
        showImageDialog: false, 
        dialogTitle: null, 
        dialogURL: null,
        showUploadDialog: false,
        dialogUploadTitle: null,
        dialogUploadId: null,
      }

      this.markBottled = this.markBottled.bind(this);
      this.createModifyProduct = this.createModifyProduct.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
      this.edit = this.edit.bind(this);
      this.updateRows = this.updateRows.bind(this);
      this.export = this.export.bind(this);

      this.fileInputMap = React.createRef();
    }

    confirmSave = () => {
        this.handleClose();
        this.props.closeConfirmDialog();
        this.createProductAPI(this.state.new_product);
    }

    createModifyProduct(e){
        e.preventDefault();
        if(this.state.new_product.name && this.state.new_product.name.trim().length > 0 && this.state.new_product.display_name && this.state.new_product.display_name.trim().length > 0 && this.state.new_product.category && this.state.new_product.unit_size && this.state.new_product.sgst >= 0 && this.state.new_product.cgst >= 0 && this.state.new_product.igst >= 0){
            this.props.showConfirmDialog("Confirm?", undefined, this.confirmSave);
        } else {
            this.props.showSnackBar('Please fill all the details and continue', 'error');
        }
    }

    createProductAPI(new_product){
        new_product.unit_price = new_product.unit_price ? parseFloat(new_product.unit_price) : 0;
        new_product.crate_size = new_product.crate_size && new_product.crate_size >= 0 ? toInt(new_product.crate_size) : 0;
        new_product.indent_inc_percentage = new_product.indent_inc_percentage && new_product.indent_inc_percentage >= 0 ? parseFloat(new_product.indent_inc_percentage) : 0;
        let new_request = new_product.id === undefined;
        // if(new_request) {
        //     new_product.id = new_product.name;
        // }
        let body = new_product;
        this.props.isLoading(true);
        ProductService.createModifyProduct(new_request, {'user-id' : this.props.user.id, 'user-name': this.props.user.name }, body)
        .then((data) => {
            this.setState({
                new_product: { name: "", barcode: null, display_name: "", category: "1", hsncode : "", unit_size: "", unit_price: 0, sgst: 0, cgst: 0, igst: 0, bottled: "0", auto_schedule_enabled: "1", crate_size: 0, indent_inc_percentage: 0}
            });
            this.fetchData();
            if(this.state.show) this.handleClose();
            this.props.isLoading(false);
            this.props.showSnackBar(`Product ${new_request ? 'Added' : 'Modifed'}`, 'success');
        })
        .catch(() => {
            this.props.isLoading(false);
            this.props.showConfirmDialog( "Product already exists with the given name.", undefined, undefined);
        });
        
    }

    edit(e, product){
        console.log(product);
        e.preventDefault();
        if(product){
            this.setState({new_product: {id: product.id, name: product.name, barcode: product.barcode, display_name: product.display_name, category: "1", hsncode : product.hsncode, unit_size: product.unit_size, unit_price: product.unit_price, sgst: product.sgst, cgst: product.cgst, igst: product.igst, bottled: product.bottled, auto_schedule_enabled: product.auto_schedule_enabled, crate_size: product.crate_size, indent_inc_percentage: product.indent_inc_percentage}}, function () {
                this.handleShow();
            });
        } else {
            this.setState({show: true});
        }
    }
 
    componentDidMount(){
        this.fetchData();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_product: { name: "", barcode: null, display_name: "", category: "1", hsncode : "", unit_size: "", unit_price: 0, sgst: 0, cgst: 0, igst: 0, bottled: "0", auto_schedule_enabled: "1", crate_size: 0, indent_inc_percentage: 0}
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_product;
        change[e.target.name] = e.target.value;
        this.setState(change);        
    }

    handleChangeCheckBox(e) {
        let change = this.state.new_product;
        change[e.target.name] = e.target.checked ?  "1" : "0";
        this.setState({new_agent: change});
    }

    fetchData(){
        this.props.isLoading(true);
        ProductService.getProductList()
        .then((data) => {
            let d = data.products.filter(p => p.status !== -1);
            this.setState({data: d.sort(function(a, b){return a.sort_order - b.sort_order}),  originalData: d.sort(function(a, b){return a.sort_order - b.sort_order})}, () => {
                this.props.setTitle(`Products ${this.state.data.length}`);
            });
            //this.updateRows(data.products);
            this.filterCriteria();
            this.props.isLoading(false);
        })
        .catch(error => {
            console.error(error);
            this.props.isLoading(false);
        });
    }

    updateRows(data){
        let rows = [];
        data.forEach((product) => {
            rows.push(<ProductDetails 
                            key={product.id} 
                            product={product} 
                            edit={this.edit} 
                            remove={this.remove} 
                            accessGranted={this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)} 
                            uploadImage={this.uploadImage}
                            openDialog={() => {
                                this.setState({showImageDialog: true, dialogTitle: product.display_name || product.name, dialogURL: product.image_url});
                            }}
                            showUploadDialog={() => {
                                this.setState({showUploadDialog: true, dialogUploadTitle: product.display_name || product.name, dialogUploadId: product.id});
                            }} />);
          });
        this.setState({rows: rows});
    }
    
    markBottled(e, product){
        e.preventDefault();
        ProductService.markBottled(product)
        .then((data) => {
            const status = data.bottled === "0" ? "non Glass": "Glass bottled";
            this.props.showSnackBar(`Marked Product as ${status}`, 'success');
            this.fetchData();
        })
        .catch(error => console.error(error));
    }

    export(e){
        e.preventDefault();
        let exportData = [["SL.NO", "NAME", "DISPLAY NAME", "EAN", "HSN CODE", "UNIT SIZE", "UNIT PRICE", "SGST %", "CGST %", "IGST %", "GLASS BOTTLED"]];
        this.props.isLoading(true);

        this.state.originalData.forEach((prod, index) => {
            let prodArray = [index + 1, prod.name, prod.display_name, prod.barcode, prod.hsncode, prod.unit_size, prod.unit_price, prod.sgst, prod.cgst, prod.igst, prod.bottled === "1" ? "Yes" : "No"];
            exportData.push(prodArray)
        });

        const wb = XLSX.utils.book_new();
        const wsAll = XLSX.utils.aoa_to_sheet(exportData);
        XLSX.utils.book_append_sheet(wb, wsAll, this.state.sheet.substring(0, 30));
        XLSX.writeFile(wb, this.state.filename + ".xlsx");

        this.props.isLoading(false);
    }

    filterCriteria(e){
        this.props.isLoading(true);
        if(e)
            e.preventDefault();
        const searchText = this.refs.inputText.value;
        let filteredList = this.state.originalData.filter(data => data.name.toLowerCase().includes(searchText.toLowerCase()) || (data.display_name && data.display_name.toLowerCase().includes(searchText.toLowerCase())) || (data.barcode && data.barcode.toLowerCase().includes(searchText.toLowerCase())));
        if(this.refs.inputText.value.length === 0){
            filteredList = this.state.originalData;
        }
        this.setState({
            data: filteredList.sort(function(a, b){return a.sort_order - b.sort_order}),
            message: filteredList.length > 0 ? '' : 'No matching Product'
        });
        this.updateRows(filteredList);
        this.props.isLoading(false);
    }

    remove = (e, product) => {
        e.preventDefault();
        this.props.showConfirmDialog("Confirm removal of Product?", undefined, () => {
            ProductService.removeProduct(product.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then(() => {
                this.fetchData();
            })
            .catch((error) => {
                this.props.showConfirmDialog("Could not remove product. There might be undelivered future schedules for this product. Delete the schedules first and try again.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
          return;
        }
    
        const originalData = reorder(
          this.state.originalData,
          result.source.index,
          result.destination.index
        );

        let oldObj = originalData[result.source.index];
        let newObj = originalData[result.destination.index];

        oldObj.sort_order = result.source.index;
        newObj.sort_order = result.destination.index;
    
        this.setState({
            originalData
        });
      }

    openSortDialog = () => {
        let children = [];
          children.push(
                <DragDropContext key={"products"} onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                        {this.state.originalData.map((product, index) => (
                            <Draggable key={product.id} draggableId={product.id} index={index}>
                            {(provided, snapshot) => (
                                <Paper
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                >
                                <span>{`[${index + 1}] ${product.name} ${product.display_name ? `(${product.display_name})` : ''}`}</span>
                                </Paper>
                            )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                        </div>
                    )}
                    </Droppable>
                </DragDropContext>
          );

        let sortButtons = (
            <Button variant="outlined" color="primary" onClick={this.saveOrder}>
                Save Order
            </Button>
        )
        this.setState({openSortDialog: true, children, sortButtons});
    }

    saveOrder = () => {
        this.props.showConfirmDialog("Confirm Save order?", undefined, this.saveProductOrder);
    }

    saveProductOrder = () => {
        this.props.closeConfirmDialog();
        let body = {};
        body.products = this.state.originalData.map(p => ({
            id: p.id,
            sort_order: p.sort_order
        }));

        ProductService.saveOrder({'user-id' : this.props.user.id, 'user-name': this.props.user.name }, body)
        .then((data) => {
            this.fetchData();
            this.handleCloseSortDialog();
            this.props.isLoading(false);
            this.props.showSnackBar(`Saved sort order`, 'success');
        })
        .catch(() => {
            this.props.isLoading(false);
            this.props.showConfirmDialog("Failed saving sort order", undefined, undefined);
        });
    }

    handleCloseSortDialog = () => {
        this.setState({openSortDialog: false, children: []});
    }

    uploadImage = () => {
        // console.log(name, files);
        let files = this.fileInputMap.current.files;
        this.props.showProgressDialog('Uploading Image');
        if(files.length === 1){
          let reader = new FileReader();
          let extension = files[0].name.split('.');
          reader.readAsDataURL(files[0]);
          reader.onload = (e) => {
            // console.log(e.target.result.split(',')[1]);
            ImportService.uploadProductImage({name: this.state.dialogUploadId, file: e.target.result.split(',')[1], extension: extension[extension.length - 1]})
            .then((data) => {
              if(data.success){
                this.props.showSnackBar("Uploaded Image", 'success');
                this.fetchData();
              }
              this.props.closeProgressDialog();
              this.setState({showUploadDialog: false, dialogUploadTitle: null, dialogUploadId: null});
            })
            .catch((error) => {
              this.props.showSnackBar("File import failed. Please try again. Check Extension and file name.", 'error');
              console.log(error);
              this.props.closeProgressDialog();
              this.setState({showUploadDialog: false, dialogUploadTitle: null, dialogUploadId: null});
            });
          }
        }
    }

    render() {
        let classes = this.props.classes;
        return (
            <div className="">
                {/* <h3 style={{marginBottom: '10px'}}></h3> */}
                <div style={{float: "right", marginTop: 8}}>
					<Typography variant="caption">
						Sort
					</Typography>
					<IconButton aria-label="close" onClick={this.openSortDialog}>
						<Icon>sort</Icon>
					</IconButton>
				</div>
                {/* <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={this.props.classes.heading}>Create New Product</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                                {this.productForm("New Product", this.createModifyProduct, "Create Product", {inline: false} )}
                    </ExpansionPanelDetails>
                </ExpansionPanel> */}
                <div className="container">
                    <Paper style={{width: "100%", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", marginBottom: 100}}>
                        <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                            <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "100%", marginBottom: "10px", padding: "5px", borderColor:"red"}} autoComplete="off"></input>
                        </form>
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    {/* <th>Display name</th> */}
                                    <th>EAN</th>
                                    <th>HSN Code</th>
                                    <th>Unit Size</th>
                                    <th>Unit Price</th>
                                    <th>SGST %</th>
                                    <th>CGST %</th>
                                    <th>IGST %</th>
                                    <th>Glass Bottled?</th>
                                    <th>Auto Scheduling</th>
                                    <th>Crate Size</th>
                                    <th>Indent Increment %</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.rows}
                            </tbody>
                        </Table>
                    </Paper>
                </div>
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{ this.state.new_product.name ? this.state.new_product.name : 'Create Product' }</DialogTitle>
                        <DialogContent>
                            <Form className="" onSubmit={this.createModifyProduct}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            label="Product Name"
                                            placeholder="Product Name"
                                            name="name"
                                            defaultValue={this.state.new_product.name}
                                            className={classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="display_name"
                                            label="Display Name"
                                            placeholder="Display Name"
                                            name="display_name"
                                            defaultValue={this.state.new_product.display_name}
                                            className={classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="barcode"
                                            fullWidth
                                            label="EAN"
                                            placeholder="EAN"
                                            name="barcode"
                                            defaultValue={this.state.new_product.barcode}
                                            className={this.props.classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            InputProps={{
                                                inputProps: {maxLength : 60}
                                            }}
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="hsncode"
                                            fullWidth
                                            label="HSN Code"
                                            placeholder="HSN Code"
                                            name="hsncode"
                                            defaultValue={this.state.new_product.hsncode}
                                            className={this.props.classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            InputProps={{
                                                inputProps: {maxLength : 10}
                                            }}
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="unit_size"
                                            fullWidth
                                            label="Unit Size"
                                            defaultValue={this.state.new_product.unit_size}
                                            placeholder="Unit Size"
                                            name="unit_size"
                                            className={this.props.classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChange}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="unit_price"
                                            fullWidth
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            label="Unit Price"
                                            margin="normal"
                                            defaultValue={this.state.new_product.unit_price}
                                            name="unit_price"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                inputProps: { min: 0 }
                                            }}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <TextField
                                            id="sgst"
                                            fullWidth
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            label="SGST"
                                            margin="normal"
                                            defaultValue={this.state.new_product.sgst}
                                            name="sgst"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                inputProps: { min: 0, max: 100 }
                                            }}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <TextField
                                            id="cgst"
                                            fullWidth
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            label="CGST"
                                            margin="normal"
                                            defaultValue={this.state.new_product.cgst}
                                            name="cgst"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                inputProps: { min: 0, max:100 }
                                            }}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <TextField
                                            id="igst"
                                            fullWidth
                                            className={this.props.classes.textField}
                                            variant="outlined"
                                            label="IGST"
                                            margin="normal"
                                            defaultValue={this.state.new_product.igst}
                                            name="igst"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                inputProps: { min: 0, max:100 }
                                            }}
                                            required
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <TextField
                                            id="crate_size"
                                            fullWidth
                                            className={classes.textField}
                                            variant="outlined"
                                            label="Crate Size"
                                            margin="normal"
                                            defaultValue={this.state.new_product.crate_size}
                                            name="crate_size"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">NOS</InputAdornment>,
                                                inputProps: { min: 0, max: 10000 }
                                            }}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="indent_inc_percentage"
                                            fullWidth
                                            className={classes.textField}
                                            variant="outlined"
                                            label="Indent Increment %"
                                            margin="normal"
                                            defaultValue={this.state.new_product.indent_inc_percentage}
                                            name="indent_inc_percentage"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            type="number"
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                inputProps: { min: 0, max: 100 }
                                            }}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    style={{marginLeft: 16}}
                                                    checked={this.state.new_product.bottled === "1" ? true : false}
                                                    onChange={this.handleChangeCheckBox} 
                                                    name="bottled"
                                                    />
                                                }
                                            label="Bottled"
                                            labelPlacement="end"
                                            />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={this.state.new_product.auto_schedule_enabled === "1"}
                                                onChange={this.handleChangeCheckBox}
                                                color="primary"
                                                name="auto_schedule_enabled"
                                            />
                                            }
                                            label="Should the product be Auto scheduled"
                                        /> 
                                    </Grid>
                                </Grid>
                            </Form>
                        </DialogContent>
                        <DialogActions>
                            <Button disabled={this.props.loading} variant="outlined" size="medium" color="primary" type="submit" onClick={this.createModifyProduct} style={{marginRight: "10px"}}>Modify</Button>
                            {false && !this.state.show ? (<Button type="submit" variant="contained" size="medium" color="primary" onClick={this.export} style={{marginRight: "10px"}}>Export</Button>): ""}
                            {this.state.show ? (<Button variant="outlined" size="medium" color="primary" onClick={this.handleClose}>Close</Button>): ""}
                        </DialogActions>
                </Dialog>
                
                {   (this.props.user.roles.includes(ROLES.ADMIN) || this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) && 
                    <Fab variant="extended" onClick={this.edit} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '86.5%'}}>
                        <AddIcon />
                        Add Product
                    </Fab>
                }
                <CustomDialog fullWidth maxWidth="sm" title={"Sort Products"} buttonText={"CLOSE"} handleClose={this.handleCloseSortDialog} open={this.state.openSortDialog} buttons={this.state.sortButtons}>
					{this.state.children}
				</CustomDialog>
                <MyDialog
                    maxWidth={"sm"}
                    content={
                            <Grid container justify="center">
                                <Grid item xs={12} lg={6}>
                                    <img 
                                        src={this.state.dialogURL} 
                                        height="300" width="300" 
                                        alt=""/>
                                </Grid>
                            </Grid>
                        }
                    title={this.state.dialogTitle}
                    open={this.state.showImageDialog}
                    close={() => {
                        this.setState({showImageDialog: false, dialogTitle: null, dialogURL: null}); 
                    }}/>
                <MyDialog
                    maxWidth={"sm"}
                    content={
                            <Grid container justify="center" alignContent="center" style={{marginTop: 20}}>
                                <Grid item xs={12} lg={6}>
                                    <input type="file" name="product_image" accept=".png,.jpg" ref={this.fileInputMap}/>
                                </Grid>
                                <Grid>
                                    <Button variant="contained" color="primary" size="small"  onClick={this.uploadImage}>Upload Image</Button>
                                </Grid>
                            </Grid>
                        }
                    title={this.state.dialogUploadTitle}
                    open={this.state.showUploadDialog}
                    close={() => {
                        this.setState({showUploadDialog: false, dialogUploadTitle: null}); 
                    }}/>
            </div>
        );
    }

}

class ProductDetails extends Component {

    uploadImage = () => {  
        const product = this.props.product;
        this.props.showUploadDialog(product.id);
    }

    render(){
      const product = this.props.product;
      const accessGranted = this.props.accessGranted;
    //   const format = 'YYYY-MM-DD HH:mm:SS';
    //   const time = moment(location.time, format);
      return (
        <tr>
            <td>
                <img 
                    src={product.image_url ? product.image_url : process.env.PUBLIC_URL + '/images/add-image.png'} 
                    height="75" width="75" alt="" 
                    style={{minWidth: 75, minHeight: 75, cursor: 'pointer'}}
                    onClick={(e) => {
                            if(product.image_url){
                                this.props.openDialog();
                            } else {
                                this.uploadImage()
                            }
                        }}/>
                {
                    product.image_url && (
                    <Button variant="text" color="primary" size="small" style={{padding: 0}} onClick={this.uploadImage}>{product.image_url ? 'Change': 'Upload'}{' Image'}</Button>
                )}
            </td>
            <td>
                <ListItemText primary={product.name} secondary={product.display_name ? `Display: ${product.display_name}` : ''}/>
            </td>
            {/* <td style={{maxWidth: '30vw'}}>{product.display_name}</td> */}
            <td>{product.barcode || "-"}</td>
            <td>{product.hsncode ? product.hsncode : "-"}</td>
            <td>{product.unit_size}</td>
            <td>{formatNumber(product.unit_price)}</td>
            <td>{product.sgst}</td>
            <td>{product.cgst}</td>
            <td>{product.igst}</td>
            <td>{product.bottled === "1" ? 
                (<Glyphicon glyph="glass" />) : 
                "No"
                }
            </td>
            <td>
                <HtmlTooltip arrow title={product.auto_schedule_enabled === "1" ? "Enabled" : "Disabled"}>
                    <CheckCircleIcon color={product.auto_schedule_enabled === "1" ? "primary" : "secondary"} />
                </HtmlTooltip>
                {/* <Typography variant="button" color={product.auto_schedule_enabled === "1" ? "primary" : "secondary"}>
                    {product.auto_schedule_enabled === "1" ? "Enabled" : "Disabled"}
                </Typography> */}
            </td>
            <td>
                <Typography variant="button" color="primary">
                    {product.crate_size || 0}
                </Typography>
            </td>
            <td>
                <Typography variant="button" color="primary">
                    {product.indent_inc_percentage || 0}
                </Typography>
            </td>
            <td>
                { accessGranted &&
                    <OverlayTrigger placement="bottom" overlay={tooltip("Remove Product")}>
                        <Glyphicon style={{marginRight: 10, marginTop: 10}} glyph="trash" onClick={(e) => this.props.remove(e, product)}/>
                    </OverlayTrigger>
                }
                { accessGranted &&
                    <OverlayTrigger placement="bottom" overlay={tooltip("Edit?")} >
                        <Glyphicon style={{marginRight: 10, marginTop: 10}} glyph="pencil" onClick={(e) => this.props.edit(e, product)}/>
                    </OverlayTrigger>
                }
            </td>
        </tr>
      );
    }
}

export default withStyles(styles)(Product);